import { Component, DestroyRef, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { Shared } from '../../../index';
import { ExecutionStatus, Notification } from '../../../../proxy/models/common';
import { CommonApiService } from '../../../../proxy/services/common-api.service';

@Component({
  selector: 'app-system-notification',
  imports: [
    Shared,
  ],
  templateUrl: './system-notification.component.html',
  styleUrl: './system-notification.component.scss',
})
export class SystemNotificationComponent {
  private destroyRef = inject(DestroyRef);
  private toast = inject(ToastrService);
  private commonApiService = inject(CommonApiService);

  public notification = input.required<Notification>();
  public delete = output();
  public update = output<Notification>();

  public markAsRead(event: PointerEvent, btn: HTMLButtonElement): void {
    event.preventDefault();
    event.stopPropagation();

    btn.disabled = true;
    const notification = {
      ...this.notification(),
      ViewDate: this.notification().ViewDate ? null : new Date(),
    };

    this.commonApiService.save<Notification>(notification).pipe(
      finalize(() =>  btn.disabled = false),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((res) => {
      if (res.result.status === ExecutionStatus.success) {
        if (res.enrichedAbe.ViewDate) {
          this.toast.success('Notification marked as read successfully.');
        } else {
          this.toast.success('Notification marked as unread successfully.');
        }
        this.update.emit(res.enrichedAbe);
      }
    });
  }

  public deleteNotification(event: PointerEvent): void {
    event.preventDefault();
    event.stopPropagation();

    this.commonApiService.delete(this.notification()).pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((res) => {
      if (res.result.status === ExecutionStatus.success) {
        this.toast.success('Notification deleted successfully.');
        this.delete.emit();
      }
    });
  }
}
